export default __webpack_public_path__ + "static/media/left_arrow.0ef3b248.svg";